import { Widget } from "widgets-for-react";
import * as W from "widgets-for-react";

export const any = <o>(widgets: Widget<o>[]): Widget<o> => W.any(widgets);
